import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Slide from "@mui/material/Slide";
import { Portal } from "../Portal/index.js";
import { Box } from "../Box/index.js";
import { Button } from "../Button/index.js";
import { CircularProgress } from "../CircularProgress/index.js";
import { Dialog } from "../Dialog/index.js";
import { Typography } from "../Typography/index.js";
import { useIsMobile } from "../hooks/index.js";
import { pluralize } from "../format/index.js";
import { Link } from "../Link/index.js";
import { Icon } from "../Icon/index.js";
import { useStyles } from "./DownloadNotification.styles.js";
const DownloadNotification = ({ show = true, notifications, onClose })=>{
    const { classes } = useStyles();
    const isMobile = useIsMobile();
    const downloads = notifications || [];
    const [isDialogOpened, setIsDialogOpened] = useState(false);
    const handleClose = ()=>{
        if (downloads.filter((item)=>'waiting' === item.status).length) setIsDialogOpened(true);
        else onClose();
    };
    const handleCloseDialog = ()=>{
        setIsDialogOpened(false);
    };
    const handleCancelDownloads = ()=>{
        handleCloseDialog();
        onClose();
    };
    useEffect(()=>{
        const webimButtonCorner = Array.from(document.getElementsByClassName('webim-button-corner'))[0];
        if (webimButtonCorner) if (downloads && !!downloads.length) webimButtonCorner.classList.add('webim-button-corner-right');
        else webimButtonCorner.classList.remove('webim-button-corner-right');
        const webimChat = document.getElementById('webim_chat');
        if (webimChat) if (downloads && !!downloads.length) webimChat.classList.add('webim-chat-right');
        else webimChat.classList.remove('webim-chat-right');
        return ()=>{
            if (webimButtonCorner) webimButtonCorner.classList.remove('webim-button-corner-right');
            if (webimChat) webimChat.classList.remove('webim-chat-right');
        };
    }, [
        downloads && !!downloads.length
    ]);
    if (!show) return null;
    return /*#__PURE__*/ jsx(Portal, {
        children: /*#__PURE__*/ jsxs("div", {
            className: classes.notifications,
            children: [
                /*#__PURE__*/ jsxs(Dialog, {
                    fullScreen: isMobile,
                    onClose: handleCloseDialog,
                    open: isDialogOpened,
                    children: [
                        /*#__PURE__*/ jsxs(Box, {
                            flexGrow: 1,
                            px: isMobile ? '16' : '48',
                            pt: isMobile ? '32' : '48',
                            children: [
                                isMobile && /*#__PURE__*/ jsx(Box, {
                                    mb: "8",
                                    children: /*#__PURE__*/ jsx(Link, {
                                        size: "small",
                                        onClick: handleCloseDialog,
                                        stroke: false,
                                        children: "Назад"
                                    })
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    mb: isMobile ? '20' : '48',
                                    children: /*#__PURE__*/ jsx(Typography, {
                                        variant: "h5",
                                        children: "Отменить скачивание?"
                                    })
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    mb: "48",
                                    children: /*#__PURE__*/ jsx(Typography, {
                                        color: "text.light.tertirary",
                                        children: "Загрузка документов не завершена. Все равно отменить?"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            p: "16",
                            display: "flex",
                            justifyContent: "flex-end",
                            columnGap: isMobile ? 1 : 2,
                            bgcolor: isMobile ? void 0 : 'bg.greyscale.primary',
                            children: [
                                /*#__PURE__*/ jsx(Button, {
                                    variant: isMobile ? 'quaternary' : 'tertiaryLight',
                                    onClick: handleCancelDownloads,
                                    size: "large",
                                    fullWidth: isMobile,
                                    children: "Отменить"
                                }),
                                /*#__PURE__*/ jsx(Button, {
                                    fullWidth: isMobile,
                                    size: "large",
                                    onClick: handleCloseDialog,
                                    children: isMobile ? 'Продолжить' : 'Продолжить скачивание'
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("div", {
                    className: classes.stack,
                    children: downloads && !!downloads.length && /*#__PURE__*/ jsx(Slide, {
                        direction: "left",
                        in: true,
                        mountOnEnter: true,
                        unmountOnExit: true,
                        children: /*#__PURE__*/ jsxs(Box, {
                            mb: "8",
                            className: classes.wrapper,
                            children: [
                                /*#__PURE__*/ jsxs(Box, {
                                    p: "16",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    className: classes.content,
                                    children: [
                                        /*#__PURE__*/ jsx(Box, {
                                            ml: "8",
                                            mr: "20",
                                            children: /*#__PURE__*/ jsx(Typography, {
                                                className: classes.text,
                                                color: "text.dark.primary",
                                                variant: "body3",
                                                children: "Подготовка к скачиванию"
                                            })
                                        }),
                                        /*#__PURE__*/ jsx(Button, {
                                            variant: "tertiaryDark",
                                            onClick: handleClose,
                                            icon: /*#__PURE__*/ jsx(Icon, {
                                                name: "cancel_outline",
                                                size: "24"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    className: classes.inner,
                                    bgcolor: "bg.light.primary",
                                    py: "8",
                                    display: "flex",
                                    flexDirection: "column",
                                    children: downloads.map((item)=>{
                                        var _item_text, _item_text1, _item_text2;
                                        return /*#__PURE__*/ jsxs(Box, {
                                            px: "24",
                                            py: "8",
                                            children: [
                                                'waiting' === item.status && /*#__PURE__*/ jsxs(Box, {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    children: [
                                                        (null == (_item_text = item.text) ? void 0 : _item_text.loading) || /*#__PURE__*/ jsxs("span", {
                                                            children: [
                                                                "Создаем архив (",
                                                                pluralize(item.counter, [
                                                                    'документ',
                                                                    'документа',
                                                                    'документов'
                                                                ]),
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ jsx(CircularProgress, {
                                                            size: 15
                                                        })
                                                    ]
                                                }),
                                                'complete' === item.status && /*#__PURE__*/ jsxs(Box, {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    children: [
                                                        (null == (_item_text1 = item.text) ? void 0 : _item_text1.complete) || /*#__PURE__*/ jsxs("span", {
                                                            children: [
                                                                "Архив создан (",
                                                                pluralize(item.counter, [
                                                                    'документ',
                                                                    'документа',
                                                                    'документов'
                                                                ]),
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ jsx(Icon, {
                                                            name: "check_circle_on",
                                                            size: "24",
                                                            color: "original.brand.primary"
                                                        })
                                                    ]
                                                }),
                                                'failed' === item.status && /*#__PURE__*/ jsxs(Box, {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    children: [
                                                        (null == (_item_text2 = item.text) ? void 0 : _item_text2.failed) || /*#__PURE__*/ jsxs("span", {
                                                            children: [
                                                                "Ошибка создания архива (",
                                                                pluralize(item.counter, [
                                                                    'документ',
                                                                    'документа',
                                                                    'документов'
                                                                ]),
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ jsx(Icon, {
                                                            name: "info_circle",
                                                            size: "24",
                                                            color: "accent.text.error"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.id);
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
export { DownloadNotification };
